module.exports = __webpack_public_path__ + "img/265c4e5e0004d34514e1690acdc55a17.png";